// utils/tenant.js
export const HomePageSlider = () => {
  return (
    <div className="col-lg-6">
      <div className="p-lg-5 p-4 auth-one-bg h-100">
        <div className="position-relative h-100 d-flex flex-column">
          <div className="mt-auto">
            {/* <div className="mb-3">
              <i className="ri-double-quotes-l display-4 text-success" />
            </div> */}
            <div
            // id="qoutescarouselIndicators"
            // className="carousel slide"
            // data-bs-ride="carousel"
            >
              {/* Indicators */}
              {/* <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#qoutescarouselIndicators"
                  data-bs-slide-to={0}
                  className="active"
                  aria-current="true"
                  aria-label="Slide 1"
                />
                <button
                  type="button"
                  data-bs-target="#qoutescarouselIndicators"
                  data-bs-slide-to={1}
                  aria-label="Slide 2"
                />
                <button
                  type="button"
                  data-bs-target="#qoutescarouselIndicators"
                  data-bs-slide-to={2}
                  aria-label="Slide 3"
                />
              </div> */}
              {/* <div className="carousel-inner text-center text-black pb-5">
                <div className="carousel-item active">
                  <p
                    className="fs-15 fst-italic"
                    style={{ backgroundColor: "#F2F44E" }}
                  >
                    "Generate itineraries with live prices, compare flights &
                    hotels, engage customers with AI chatbots — all in seconds."
                  </p>
                </div>
                <div className="carousel-item">
                  <p
                    className="fs-15 fst-italic"
                    style={{ backgroundColor: "#F2F44E" }}
                  >
                    "Create stunning, professional itineraries in seconds with
                    live pricing from multiple suppliers. Save hours of manual
                    work and impress your customers."
                  </p>
                </div>
                <div className="carousel-item">
                  <p
                    className="fs-15 fst-italic"
                    style={{ backgroundColor: "#F2F44E" }}
                  >
                    "Engage with travelers 24/7 through an intelligent chatbot
                    on WhatsApp. From answering FAQs to completing bookings,
                    automate conversations and boost conversions effortlessly."
                  </p>
                </div>
              </div> */}
            </div>
            {/* end carousel */}
          </div>
        </div>
      </div>
    </div>
  );
};
